<template>
  <div class="afdc-fuel-filters-box">
    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-lng-vehicle-class">{{ $t('Vehicle accessibility') }}</label>
      <div class="afdc-col-sm-8">
        <select v-model="queryLngVehicleClass" class="afdc-form-control afdc-custom-select" id="afdc-analyze-lng-vehicle-class">
          <option v-for="option in vehicleClassOptions" v-bind:key="option.key" v-bind:value="option.key">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

</template>

<script>
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  computed: {
    vehicleClassOptions() {
      return this.$store.getters.loaderLngVehicleClasses;
    },

    queryLngVehicleClass: syncInputRouteQuery('lng_vehicle_class'),
  },
};
</script>

<style lang="scss">
</style>
